export const renderAgendaTime = (time: string | null | undefined) => {
  if (!time) {
    return (
      <span className='text-slate-300 text-[10px] font-medium uppercase tracking-wider flex items-center gap-1 select-none'>
        --:--
      </span>
    );
  }

  const timeStr = String(time);

  const dateObj = new Date(
    timeStr.includes('T') ? timeStr : `1970-01-01T${timeStr}Z`
  );

  const hours = dateObj.getUTCHours().toString().padStart(2, '0');
  const minutes = dateObj.getUTCMinutes().toString().padStart(2, '0');
  const displayTime = `${hours}:${minutes}`;

  return (
    <div className='flex items-center gap-2 group w-fit'>
      <span className='text-sm font-bold text-slate-600 font-numeric tracking-tight group-hover:text-violet-700 transition-colors duration-300'>
        {displayTime}
        <span className='text-[10px] text-slate-400 font-medium ml-0.5 uppercase'>
          hs
        </span>
      </span>
    </div>
  );
};
